
import successIcon from '@/assets/tab-pics/success-icon.png'
import failIcon from '@/assets/tab-pics/warning-icon.png'
import errorIcon from '@/assets/tab-pics/error-icon.png'
import IconOffer from '@/assets/survey/Icon-Offer claimed.svg'
import IconMaining from '@/assets/survey/Icon-Maining Opt-in.svg'
import { t } from '@/utils/language'

class Dialog {
  constructor({
    custom = false, // If it is true, the dialog will not be initiated in the axios interceptor, and it needs to be processed in .vue   // 如果是 true，不会在axios拦截器里发起 dialog，需要在 .vue 里处理
    icon = failIcon,
    title = '',
    content = '',
    secContent = '',
    buttonText = 'OK'
  }) {
    this.custom = custom
    this.icon = icon
    this.title = title
    this.content = content
    this.secContent = secContent
    this.buttonText = buttonText
  }
}

export const ready = new Dialog({
  icon: successIcon,
  title: 'Your tab is ready to go!',
  content: 'You can now place orders using your tab. You can also share your unique tab code with others to get the party started!',
  buttonText: 'OK',
  _meta: '创建 tab 成功',
})

export const customReadyTab = new Dialog({
  icon: successIcon,
  title: 'Your tab is ready to go!',
  content: 'You can now place orders using your tab. You will only be charged for what you spend once the tab is closed.',
  buttonText: 'GOT IT',
  _meta: '创建 tab 成功 custom create tab',
})

export const no_tab = new Dialog({
  title: 'No tab found',
  content: 'We couldn\'t find a tab with this code. Please re-check your code and try again.',
  _meta: 'tab 不存在',
})

export const close_tab = new Dialog({
  title: 'The tab has been closed',
  content: '',
  _meta: 'tab 已关闭',
})

export const wrong_pass_code = new Dialog({
  title: 'Wrong Code',
  content: 'Please re-type correct code to access.',
  _meta: '错误的passcode',
})

export function campaignTab(email, content, title) {
  return new Dialog({
    icon: IconOffer,
    title: title || t('offer_claimed', 'Offer claimed!'),
    content: content || `${t('offer_sent_to', 'Details of the offer have been sent to')} ${email ?? ''}`,
    buttonText: t('ok', 'OK'),
  })
}

export function campaignLastSurvey(content) {
  return new Dialog({
    icon: IconOffer,
    title: t('thank_you', 'Thank you!'),
    content: content || t('hope_see_you_soon', 'We hope to see you soon.'),
    buttonText: t('ok', 'OK'),
  })
}

export function campaignMainTab() {
  return new Dialog({
    icon: IconMaining,
    title: t('thank_you', 'Thank you!'),
    content: t('joined_mailing_list', 'You have successfully joined our mailing list.'),
    buttonText: t('ok', 'OK'),
  })
}

export function campaignFailTab() {
  return new Dialog({
    icon: failIcon,
    title: t('oops', 'Oops!'),
    content: t('something_went_wrong', 'Something went wrong. There was a problem submitting your answer.'),
    buttonText: t('ok', 'OK'),
  })
}
// export const customReadyTab = new Dialog({
//   icon: successIcon,
//   title: 'Thank you!',
//   content: 'You have successfully joined our mailing list.',
//   buttonText: 'GOT IT',
//   _meta: '创建 tab 成功 custom create tab',
// })

// normal 错误需要在 .vue 里处理，不在 axios response 拦截里处理
// export const normal = new Dialog({
//   title: 'normal', // TODO: 待补充
//   content: 'normal', // TODO: 待补充
//   _meta: '错误的passcode',
// })

export const tab_insufficient_fund_increase_tab = new Dialog({
  title: 'Insufficient funds',
  content: 'There are insufficient funds remaining on your card. You will need to set up a new tab with a different card.',
  _meta: 'Increase tab - Fail'
})

export const tab_insufficient_fund_payment = new Dialog({
  title: 'Insufficient funds',
  content: 'There are insufficient funds remaining on your card. We are unable to set up your tab using these payment details.',
  _meta: 'update的时候信用卡无法更新或者预付款，对应的页面是  Payment details - Insufficient funds'
})

export const tab_insufficient_fund_user_pay = new Dialog({
  title: 'Insufficient funds',
  content: 'This tab has reached its limit. Please select a different payment method.',
  _meta: '其他用户支付时，提示的支付错误'
})

export const tab_insufficient_fund_not_tab_owner = new Dialog({
  title: 'The order takes the tab over the limit',
  content: 'This order will exceed the tab limit. Please ask tab owner to increase the limit.',
  _meta: '不是 tab owner 情况下的 tab_insufficient_fund'
})

// $insertStr insert string position
// $insertStr 插入字符串位置
export const tab_wrong_date = new Dialog({
  custom: true,
  title: 'Tab hasn’t started yet',
  content: 'You can order on this tab from $insertStr',
  _meta: '代表错误的日期和时间，content 需要传入变量',
})

export const payment_fail = new Dialog({
  title: 'Payment error',
  content: 'There was a problem processing your payment details. Please try again or use a different card.',
  _meta: '无法使用此信用卡',
})

// 'closeTabSuccess' is customized, not returned by the interface
// 'closeTabSuccess' 是自定义的，不是接口返回的
export const closeTabSuccess = new Dialog({
  icon: successIcon,
  title: 'Tab closed',
  content: 'This tab is now closed. No more payments will be accepted.',
  _meta: 'close tab 成功的时候',
})

export const charge_payment_fail = new Dialog({
  title: 'Error',
  icon: errorIcon,
  content: 'Sorry, the system can not close your tab. Please contact the venue staff to solve the issue.',
  _meta: 'close tab的时候信用卡支付失败',
})

export const wrong_status = new Dialog({
  title: 'Your tab is closed',
  content: 'No more funds can be added.',
  _meta: 'wrong status',
})

export const tab_is_open = new Dialog({
  title: 'Tab is open',
  content: 'Can not update info due to tab is open. Will jump to menu page.',
  _meta: 'tab是open status，则不允许update info',
})

export const othersStartTabError = new Dialog({
  title: 'Oops!',
  content: 'We had a problem setting up your tab using this card. Please try again or select a different payment method.',
  _meta: 'othersStartTabError',
})

export const tabCopyCode = new Dialog({
  title: 'Take note!',
  content: 'People you share your code with will be able to place orders using the funds on your tab. Be mindful who you give it to.',
  _meta: '点击 Share tab code 后',
})

export const delineryAddress = new Dialog({
  title: 'Please edit the order details to change the delivery address.',
  content: 'This address is not in the delivery range of takeout',
  _meta: 'delinery 判断配送地址是否可用',
})

export const delinery = new Dialog({
  title: '',
  content: '',
  _meta: 'delinery 判断',
})
